import type { BtlApplication } from 'api/btlApplicationForm/types';
import {
  buildOoCaseSidebar,
  CaseSidebar,
  getVisibleOoCaseSidebarItemIds,
  mapOoCaseSidebarItemToUrlSection,
  resolveOoCaseSidebarItemId,
  shouldShowOoOverviewNavItem,
} from 'components/CaseSidebar';
import type { OoCaseSidebarContext } from 'components/CaseSidebar/buildOoCaseSidebar';
import { CaseSidebarItemId } from 'components/CaseSidebar/types';
import type { ApplicationDetailsFormatted } from 'queries/applications/useApplicationByReferenceNumber/types';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

interface OoCaseSidebarProps {
  application: ApplicationDetailsFormatted;
  caseData?: BtlApplication;
  isCaseLoading?: boolean;
  currentSection?: string;
  context: OoCaseSidebarContext;
}

function getCaseSummaryTitle(application: ApplicationDetailsFormatted): string {
  return application.applicant2 ? `${application.applicant1} & ${application.applicant2}` : application.applicant1;
}

export function OoCaseSidebar({ application, caseData, isCaseLoading, currentSection, context }: OoCaseSidebarProps) {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const activeItemId =
    resolveOoCaseSidebarItemId(currentSection, context) ??
    getVisibleOoCaseSidebarItemIds(context)[0] ??
    CaseSidebarItemId.OVERVIEW;

  const handleItemSelect = (itemId: CaseSidebarItemId) => {
    navigate({ search: `?section=${mapOoCaseSidebarItemToUrlSection(itemId)}` });
  };

  const { overviewItem, state } = buildOoCaseSidebar({ formatMessage, context, application: caseData });

  return (
    <CaseSidebar
      overviewItem={overviewItem}
      state={state}
      activeItemId={activeItemId}
      onItemSelect={handleItemSelect}
      headerTitle={getCaseSummaryTitle(application)}
      referenceNumber={application.salesforceId}
      statusLabel={formatMessage({ id: `applicationStatus.${application.status}` })}
      application={caseData}
      isLoading={isCaseLoading}
      showOverviewItem={shouldShowOoOverviewNavItem(context)}
    />
  );
}
